module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-1-e30189716ae579992fcac746e557451a.jpg";